/**
 * Handle the action of communication to service-worker
 */
class ExtensionService {
    /**
     * Fetch the document to preview
     * @param {string} token Token of document to preview
     * @return {Promise<{ title: string, author: string, url: string, date: string, source: string, htmlContent: string, epubString: string}>} Metadata and content of document to preview
     */
    async fetchDocument(token) {
        const res = await chrome.runtime.sendMessage({
            action: "fetch-document",
            data: {
                token
            }
        });

        const { title, author, url, string, publicationDate, source, content, epubString} = res?.data?.data;

        return {
            title,
            author,
            url,
            string,
            date: publicationDate,
            source, 
            htmlContent: content,
            epubString: epubString
        };
    }

    /**
     * Update the metadata(title and author) of current shown document
     * @param {string} token Token of document to update
     * @param {{title: string, author:string, epubString:string}} metadata metadata of document
     * @param {function} callback Complete callback
     */
    updateMetadata(token, metadata, callback) {
        chrome.runtime.sendMessage({
            action: "update-document",
            data: {
                "isFromSend": true,
                token, 
                ...metadata
            }
        }, callback);
    }

    /**
     * Trigger the sending workflow from preview
     * @param {string} token Token of document to send
     * @param {function(res: { success: boolean, statusCode: number, statusText: string, data: {}, contentType: string | undefined }): void}callback
     */
    sendDocument(token, callback) {
        chrome.runtime.sendMessage({
            action: "send-document",
            data: {
                token,
                context: "Preview"
            }
        }, callback);
    }
}

export { ExtensionService };
